import fetchData from 'src/utils/fetchData';

export const getAllowedBanksAPI = async (partnerBankIslMemberId?: string) => {
  const urlBase = '/ui/front-api/public/banks/applications/allowed-banks';
  const url = partnerBankIslMemberId
    ? `${urlBase}?partnerBankIslMemberId=${partnerBankIslMemberId}`
    : urlBase;
  return fetchData(url);
};

export const getFormDataAPI = async (bankUeid?: string) => {
  return fetchData(`/ui/front-api/public/banks/applications/from-data?bankUeid=${bankUeid}`);
};

export const postApplicationAPI = async (data: any) => {
  return fetchData('/ui/front-api/public/banks/applications', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
};
